<app-ark-container
  [future]="dataObservable"
  [loadingTemplate]="loading"
  [successTemplate]="success"
  [failureTemplate]="failure"
  [errorTemplate]="error"
  (onSuccess)="onTearsheetDataResolved($event[0])"
>
</app-ark-container>

<ng-template #loading>
  <va-preview-list
    sectionHeader="Tear Sheets"
    height="297px"
    isLoading="loading"
  ></va-preview-list>
</ng-template>
<ng-template #failure>
  <div class="error-container" style="height: calc(100% - 60px);">
    <div class="error-msg" style="text-align: center;  top: 50px;">
      <va-icon name="exclamation-triangle" class="info-icon"></va-icon>
      <span class="error-text">Data is not available</span>
    </div>
  </div>
</ng-template>
<ng-template #error>
  <div class="error-container" style="height: calc(100% - 60px);">
    <div class="error-msg" style="text-align: center;  top: 50px;">
      <va-icon name="exclamation-triangle" class="info-icon"></va-icon>
      <span class="error-text">Tear Sheets could not be loaded</span>
    </div>
  </div>
</ng-template>
<ng-template #success>
  <va-preview-list
    sectionHeader="Tear Sheets"
    height="220px"
    [sectionSubHeaderTemplate]="sectionSubHeaderTemplate"
    [dataHeaderTemplate]="headerTemplate"
    [dataRowTemplate]="rowTemplate"
    [data]="tearSheetData"
  ></va-preview-list>
</ng-template>

<ng-template #sectionSubHeaderTemplate>
  <div class="tear-sheets-text">
    <span>
      Visible Alpha tear sheets provide you with one click access to earnings
      previews, reviews and surprise analysis in Excel
    </span>
  </div>
</ng-template>
<ng-template #headerTemplate>
  <div class="item">Item</div>
  <div class="focus">Focus</div>
  <div class="download">Download</div>
</ng-template>
<ng-template #rowTemplate let-row="row">
  <div class="item">
    {{ row.item }}
  </div>
  <div class="focus">{{ row.focus }}</div>
  <div class="download-icon">
    <span *ngIf="row.showDownload" title="Download">
      <va-icon size="small" name="download" (click)="tearsheetDownload(row)"></va-icon>
    </span>
  </div>
</ng-template>
